import BulletinTeaser from "features/bulletins/components/BulletinTeaser";
import Alert from "components/ui/Alert/Alert";
import { useView } from "features/view/context/ViewContext";
import Empty from "features/view/components/Empty/Empty";
import Trans from "features/translation/components/Trans";
import Loader from "components/ui/Loader/Loader";
import ViewPager from "features/view/components/Pager/ViewPager";

const ViewGroupBulletins = () => {
  const { view, isLoading } = useView();

  if (!isLoading && !view) {
    return <Alert/>;
  }

  let results = view?.search_results && view.search_results.map(
      (row, index) => <BulletinTeaser key={ index }
                                      data={ row }
                                      teaserVariant={ `dark` }
                                      labelVariant={ `light` }
                                      buttonVariant={ `white` }/>
  );

  if (!results && !isLoading) {
    results = <Empty><Trans text="Er zijn geen groepsberichten gevonden."/></Empty>;
  }

  return (
    <div className={ 'grid--content' }>
      <div className={ 'teasers-container--1col' }>
        { isLoading ? <Loader containerVariant={ 'center' }/> : results }
      </div>
      <ViewPager/>
    </div>
  );
}

export default ViewGroupBulletins;
